import {
	brokerContactCreationSubRoles,
	contactCreationRoles,
	contactSelect,
	duneContactCreationSubRoles,
} from "@dune/vars";
import type { Prisma } from "@prisma/client";

export enum ListContactsFilter {
	ALL = "ALL",
	CONTACTS = "CONTACTS",
	USERS = "USERS",
	BROKERS = "BROKERS",
	SYNDICS = "SYNDICS",
	CLIENTS = "CLIENTS",
	INSURERS = "INSURERS",
	TPAS = "TPAS",
}

export type ContactCreationRoles = (typeof contactCreationRoles)[number];

export type BrokerContactCreationSubRole =
	(typeof brokerContactCreationSubRoles)[number];
export type DuneContactCreationSubRole =
	(typeof duneContactCreationSubRoles)[number];

export type ContactPayload = Prisma.UserGetPayload<{
	select: typeof contactSelect;
}>;
